<template>
  <div class="w-flow" style="width:100%;height:100%">    
    <flow-chart
      ref="diag"      
      :model-data="diagramData"
      @model-changed="modelChanged"
      @undo-changed="updateDiagramFromData"
      @changed-selection="changedSelection">
    </flow-chart>
  </div>
</template>
<script>
import FlowChart from './FlowChart'
export default {
  components: {
    FlowChart
  },
  props: {
    diagramData: {}
  },
  data() {
    return {
      currentNodeType: 'node',
      currentNodeData: {},
      currentNode: {},
      savedModelText: ''
    }
  },
  computed: {
    currentNodeText: {
      get: function() {
        var node = this.currentNode
        if (node !== null) {
          return node.data.key
        } else {
          return ''
        }
      },
      set: function(val) {
        var node = this.currentNode
        if (node !== null) {
          var model = this.model()
          model.startTransaction()
          model.setDataProperty(node.data, 'text', val)
          model.commitTransaction('edited text')
        }
      }
    }
  },
  watch: {
    currentNode(newVal) {
      if (newVal !== null) {
        this.currentNodeData = this.currentNode.data.from !== undefined
          ? this.diagramData.linkDataArray.find(l => l.key === this.currentNode.data.key)
          : this.diagramData.nodeDataArray.find(n => n.key === this.currentNode.data.key)
        this.currentNodeType = this.currentNode.data.from !== undefined ? 'link' : 'node'
        if (this.currentNodeType === 'node') {
          this.$emit('handleFlowNodeClick', this.currentNodeData)
        }
      } else {
        this.currentNode = null
        this.$emit('clearSelection')
      }
    }
  },
  methods: {
    changeToggle() {
      this.$refs.diag.clearSelection()
      this.currentNode = null
    },
    model: function() { return this.$refs.diag.model() },
    updateDiagramFromData(form) {
      this.$nextTick(() => {
        this.$refs.diag.updateDiagramFromData()
      })
    },
    modelChanged: function(e) {
      if (e.isTransactionFinished) { // show the model data in the page's TextArea
        this.savedModelText = e.model.toJson()
      }
    },
    changedSelection: function(e) {
      var node = e.diagram.selection.first()
      if (node !== null) {
        if (node.data.key === undefined) {
          this.$set(node.data, 'key', node.data.__gohashid)
          this.$set(node.data, 'color', '#1a78b4')
          this.$set(node.data, 'category', '')
        }
        this.currentNode = node
        this.currentNodeText = node.data.text
      } else {
        this.currentNode = null
        this.currentNodeText = ''
      }
    }
  }
}
</script>
<style lang="scss">
  .w-flow{
    .float-botton{
      position: absolute;
      z-index: 1;
      top:5px;
      right:80px;
      display: none;
    }
    canvas:focus{
      outline:none !important;
    }
  }
  .w-flow:hover .float-botton{
    display: block;
  }
  .w-flow-card{
    .el-card__header{
      padding:10px 20px;
    }
  }
  
</style>